import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import FloatingShapes from "@/components/FloatingShapes";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import AdSlot from "@/components/AdSlot";

// Static, crawlable marketing/landing page used by the /tools and /use-cases routes.
// Content is passed in as props; titles/descriptions live in Seo.jsx.
export default function MarketingPage({ tag, h1, intro, sections = [], ctaText = "Upload your PDF free", testid }) {
  return (
    <div className="relative min-h-screen grain" data-testid={testid}>
      <FloatingShapes />
      <Nav />
      <main className="relative z-10 max-w-3xl mx-auto px-6 pt-32 pb-24">
        <motion.div
          initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}
        >
          {tag && <span className="tag-pill" data-testid="marketing-tag">{tag}</span>}
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-6 leading-[1.06] tracking-tight" data-testid="marketing-h1">
            {h1}
          </h1>
          <p className="mt-6 text-lg text-stone-600 leading-relaxed" data-testid="marketing-intro">{intro}</p>
          <div className="mt-8 flex flex-wrap items-center gap-4">
            <Link to="/register" className="btn-primary" data-testid="marketing-cta-primary">{ctaText}</Link>
            <Link to="/pricing" className="btn-ghost" data-testid="marketing-cta-pricing">See pricing</Link>
          </div>
        </motion.div>

        <div className="mt-14 space-y-10">
          {sections.map((s, i) => (
            <section key={i} className="sticky-card p-8" data-testid={`marketing-section-${i}`}>
              <h2 className="font-display text-2xl sm:text-3xl leading-tight">{s.h2}</h2>
              {s.body.map((p, j) => (
                <p key={j} className="text-stone-600 mt-4 leading-relaxed">{p}</p>
              ))}
            </section>
          ))}
        </div>

        <div className="mt-14">
          <AdSlot id={`${testid}-footer`} label="Advertisement" />
        </div>

        <div className="mt-14 text-center">
          <Link to="/register" className="btn-primary inline-block" data-testid="marketing-cta-bottom">{ctaText}</Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
